// 무효 클릭 방지기 (invalid-click protector)
// 한 방문자가 짧은 시간에 광고를 반복 클릭하면, 그 방문자에게는 광고를 꺼서
// 구글로 가는 무효 클릭 수를 줄인다. (localStorage 기반, 프론트 전용)
//
// 원리: 광고를 클릭하면 포커스가 구글 광고 iframe(aswift_* / google_ads_iframe)으로
// 넘어가 window 'blur'가 발생한다. 그때 activeElement가 광고 iframe이면 광고 클릭으로 카운트.
// (교차출처 iframe 내부는 못 읽지만 이 포커스 트릭은 표준 기법)

const ADSENSE_CLIENT = 'ca-pub-2823139596932888'
const STORAGE_KEY = 'ad_guard_v1'

const DAY_MS = 24 * 60 * 60 * 1000
const WINDOW_MS = 3 * 60 * 1000     // 단시간 창: 3분
const MAX_CLICKS_WINDOW = 3         // 3분 내 3회 이상이면 남용
const MAX_CLICKS_DAY = 5            // 하루 5회 이상이면 남용
const COOLDOWN_MS = DAY_MS          // 남용 판단 시 24시간 광고 차단

function loadState() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {} }
  catch (e) { return {} }
}

function saveState(s) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)) }
  catch (e) { /* localStorage 사용 불가 시 무시 */ }
}

function inCooldown(s) {
  return !!s.cooldownUntil && Date.now() < s.cooldownUntil
}

function injectAdsense() {
  if (document.getElementById('adsbygoogle-loader')) return
  const el = document.createElement('script')
  el.id = 'adsbygoogle-loader'
  el.async = true
  el.crossOrigin = 'anonymous'
  el.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' + ADSENSE_CLIENT
  document.head.appendChild(el)
}

// 이미 로드/렌더된 광고를 즉시 끈다.
function disableAds() {
  try { (window.adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 1 }
  catch (e) { /* noop */ }
  const sel = 'ins.adsbygoogle, iframe[id^="aswift_"], iframe[id^="google_ads_iframe"]'
  document.querySelectorAll(sel).forEach(function (n) {
    const box = n.closest('ins.adsbygoogle') || n
    box.style.display = 'none'
  })
}

function isAdIframe(el) {
  if (!el || el.tagName !== 'IFRAME') return false
  const id = el.id || ''
  const name = el.name || ''
  const src = el.src || ''
  return id.indexOf('aswift_') === 0
    || id.indexOf('google_ads_iframe') === 0
    || name.indexOf('aswift_') === 0
    || /googlesyndication|doubleclick|googleads/.test(src)
}

function registerAdClick() {
  const now = Date.now()
  const s = loadState()
  const clicks = (s.clicks || []).filter(function (t) { return now - t < DAY_MS })
  clicks.push(now)
  s.clicks = clicks

  const inWindow = clicks.filter(function (t) { return now - t < WINDOW_MS }).length
  if (inWindow >= MAX_CLICKS_WINDOW || clicks.length >= MAX_CLICKS_DAY) {
    s.cooldownUntil = now + COOLDOWN_MS
    saveState(s)
    disableAds()
  } else {
    saveState(s)
  }
}

export function initAdGuard() {
  if (typeof window === 'undefined') return

  const s = loadState()
  if (inCooldown(s)) return   // 쿨다운 중이면 로더 미주입 → 광고 안 뜸

  injectAdsense()

  // 광고 클릭 감지
  window.addEventListener('blur', function () {
    // blur 직후 activeElement가 확정되도록 다음 틱에 확인
    setTimeout(function () {
      if (isAdIframe(document.activeElement)) registerAdClick()
    }, 0)
  })
}
